import * as React from "react";
const SvgFiRrBlockQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-block-question_svg__a)">
      <path
        fill="#062147"
        d="M15.536 7.068c1.004 2.04.313 4.377-1.606 5.437-.521.287-.93.944-.93 1.495a1 1 0 0 1-2 0c0-1.274.808-2.609 1.963-3.247.844-.465 1.382-1.576.778-2.802a1.55 1.55 0 0 0-.692-.692c-.991-.487-1.743-.183-2.104.041A1.99 1.99 0 0 0 10 9a1 1 0 1 1-2 0c0-1.392.706-2.662 1.889-3.398 1.213-.756 2.688-.805 4.042-.138.693.341 1.264.91 1.605 1.604M24 5v14c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3zM5.5 17a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 17m0-13a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 4m13 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 4m0 13a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 17M12 16a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 16"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-block-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBlockQuestion;
